import {en} from './locales/en';
import {es} from './locales/es';

export type Language = 'en' | 'es';

export const translations = {en, es};

export type TranslationKeys = typeof en;

export const getTranslation = (language: Language): TranslationKeys => {
  return translations[language] || translations.en;
};

export const t = (language: Language, key: string): string => {
  const translation = getTranslation(language);
  const keys = key.split('.');
  let value: any = translation;

  for (const k of keys) {
    value = value?.[k];
  }

  return value || key;
};
